import { useMutation } from '@tanstack/react-query'
import React, { useEffect } from 'react'
import { apiClient } from '../helpers/Axios'
import { useNavigate } from 'react-router-dom'
import ContentLoader from 'react-content-loader'
import LogError from '../components/LogError'
import { useUserContext } from '../context/UserContext'

function Logout() {

    const navigate = useNavigate()
    const { setUser } = useUserContext()

    const { isPending, mutate, isError } = useMutation({
        mutationFn: () => {
            return apiClient.post('/auth/logout')
        },
        onSuccess: (data) => {
            navigate('/')
            setUser(undefined)
        }
    })

    useEffect(() => {
        mutate()
    }, [mutate])


    if (isPending) {
        return (
            <div className="flex">
                <ContentLoader
                    viewBox="0 0 400 160"
                    height={160}
                    width={400}
                    backgroundColor="transparent"
                >
                    <circle cx="150" cy="86" r="8" />
                    <circle cx="194" cy="86" r="8" />
                    <circle cx="238" cy="86" r="8" />
                </ContentLoader>
            </div>
        )
    }

    if (isError) {
        return (
            <div className='py-20 flex justify-center items-center'>
                <LogError error={{ response: { data: "Error occured while trying to logout" } }} />
            </div>
        )
    }

}

export default Logout